"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var context_1 = require("./context");

exports.doesUserExist = context_1.doesUserExist;
exports.useXyAccountContext = context_1.useXyAccountContext;
exports.useXyAccountAccessToken = context_1.useXyAccountAccessToken;
exports.useXYUserExistsServiceUri = context_1.useXYUserExistsServiceUri;
exports.XYOAccountProvider = context_1.Provider;
exports.XYOAccountConsumer = context_1.Consumer;

var Private_1 = require("./Private");

exports.Private = Private_1.default;

var SignIn_1 = require("./SignIn");

exports.SignIn = SignIn_1.default;

var SignUp_1 = require("./SignUp");

exports.SignUp = SignUp_1.default;

var Login_1 = require("./Login");

exports.Login = Login_1.default;

var Google_1 = require("./Google");

exports.Google = Google_1.default;

var Facebook_1 = require("./Facebook");

exports.Facebook = Facebook_1.default;

var ResetPassword_1 = require("./ResetPassword");

exports.ResetPassword = ResetPassword_1.default;